import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Style from './index.css';

const Page4 = () => {
    return (
        <div className={Style.page4}>
            <div className={Style.imageWp}>
                <a href="https://www.gzxijiu.com" target="_blank" className={Style.imageWpLeft}>
                    <img src="https://x0.ifengimg.com/ucms/2023_45/944AD9EA9CB1DB91C41EA9A8CFA4A817B1E10A15_size143_w265_h581.png" className={Style.xiImage} alt="" />
                </a>
                <div className={Style.imageWpRight}>
                    <a href="https://www.gzxijiu.com" target="_blank">
                        <img src="https://x0.ifengimg.com/ucms/2023_45/079DE81EB37D2157F45794C183AF5AB64ADD4967_size38_w1027_h122.png" className={Style.xiText} alt="" />
                    </a>
                    <div className={Style.textWp}>
                        <span className={Style.textTitle}>往季回顾</span>
                        <div className={Style.links}>
                            <a href="https://v.ifeng.com/c/special/7sRswMTLvoO" target="_blank" rel="noreferrer">
                                第一季
                                <img src="https://x0.ifengimg.com/ucms/2023_45/0BFE316A518203CC259BE277DA444C6678565EFE_size1_w25_h27.png" alt="" />
                            </a>
                            <a href="https://v.ifeng.com/c/special/85qAA0PWo4m" target="_blank" rel="noreferrer">
                                第二季
                                <img src="https://x0.ifengimg.com/ucms/2023_45/0BFE316A518203CC259BE277DA444C6678565EFE_size1_w25_h27.png" alt="" />
                            </a>
                            <a href="https://v.ifeng.com/loc/junpintan2022" target="_blank" rel="noreferrer">
                                第三季
                                <img src="https://x0.ifengimg.com/ucms/2023_45/0BFE316A518203CC259BE277DA444C6678565EFE_size1_w25_h27.png" alt="" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default errorBoundary(Page4);
